import type { TagCategory } from '@trinity/chat';
import { createNamedContext } from '../../utils/react';

export type TagFormData = {
  title: string;
  parentId: number | null;
  category: TagCategory | null;
  includeSummary: boolean;
  color: string;
};

type TagFormContextValue = {
  data: TagFormData;
  dispatch: React.Dispatch<Partial<TagFormData>>;
};

export const TagFormContext = createNamedContext<TagFormContextValue | undefined>(
  undefined,
  'Tag.Form.Context'
);
